<template>
  <div>
    <div id="canvas-wrapper" class="d-none" />
  </div>
</template>

<script>
import QRCodeStyling from "qr-code-styling";
import { debounce } from "@/main";
let qrCode = null;

export default {
  name: "qrCodeMakeNfc",
  props: {
    value: Object,
    canvasId: String,
    file: String,
    identifier: String,
  },
  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeMake",
    options: {
      width: 300,
      height: 300,
      data: "https://qr2.in",
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 0,
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "#6a1a4c",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#933490" },
            { offset: 1, color: "#933490" },
          ],
        },
      },
      backgroundOptions: { color: "#FFFFFFFF" },
      image: null,
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#6a1a4c",
          color2: "#6a1a4c",
          rotation: "0",
        },
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        color: "#690a70",
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      cornersDotOptions: { type: "", color: "#b00cab" },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#ffffff",
          color2: "#ffffff",
          rotation: "0",
        },
      },
    },
    panels: [], // Initialize as an empty array
    colors: [
      ["#649173", "#DBD5A4"],
      ["#B993D6", "#8CA6DB"],
      ["#870000", "#190A05"],
      ["#00d2ff", "#3a7bd5"],
      ["#DAD299", "#B0DAB9"],
      ["#E6DADA", "#274046"],
      ["#50C9C3", "#96DEDA"],
      ["#4b6cb7", "#182848"],
      ["#EC6F66", "#F3A183"],
      ["#5f2c82", "#49a09d"],
    ],
  }),
  created() {
    this.panels = [
      {
        name: "QrCodeData",
        title: this.$t("qr_color_size"),
        icon: "qrcode-edit",
      },
      {
        name: "QrCodeDots",
        title: this.$t("dots_design_color"),
        icon: "dots-triangle",
      },
      {
        name: "QrCodeEye",
        title: this.$t("eye_design_color"),
        icon: "bullseye",
      },
      {
        name: "QrCodeSquare",
        title: this.$t("border_design_color"),
        icon: "rounded-corner",
      },
      {
        name: "QrCodeLogo",
        title: this.$t("logo_settings"),
        icon: "pig-variant-outline",
      },
      { name: "QrCodeOptions", title: this.$t("qr_settings"), icon: "cogs" },
    ];
  },
  async mounted() {
    if (this.identifier) {
      this.options = {
        ...this.options,
        data: `https://qr2.in/${this.identifier}`,
      };
    }
    qrCode = new QRCodeStyling(this.options);

    if (this.value && Object.keys(this.value).length) {
      const keys = Object.keys(this.value);
      if (
        keys.includes("imageOptions") &&
        keys.includes("qrOptions") &&
        keys.includes("dotsOptions") &&
        keys.includes("backgroundOptions") &&
        keys.includes("cornersSquareOptions") &&
        keys.includes("cornersDotOptions")
      ) {
        this.options = this.value;
        if (this.identifier) {
          this.options = {
            ...this.options,
            data: `https://qr2.in/${this.identifier}`,
          };
        }
      } else {
        await this.ranColor();
        this.updateStyle();
        this.$emit("save", this.options);
        this.$emit("input", this.options);
      }
    } else {
      await this.ranColor();
      this.updateStyle();
      this.$emit("save", this.options);
      this.$emit("input", this.options);
    }
    qrCode.append(document.getElementById("canvas-wrapper"));
    this.updateStyle();
    this.$emit("input", this.options);
    this.$emit("save", this.options);
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    identifier(newVal) {
      if (newVal) {
        this.options = { ...this.options, data: `https://qr2.in/${newVal}` };
        if (qrCode) {
          qrCode.update(this.options);
          this.getDataUrl();
        } else {
          qrCode = new QRCodeStyling(this.options);
          qrCode.append(document.getElementById("canvas-wrapper"));
          qrCode.update(this.options);
          this.getDataUrl();
        }
      }
    },
    value: {
      handler(newVal) {
        if (newVal) {
          Object.assign(this.options, newVal);
          this.updateStyle();
        }
      },
      deep: true,
    },
  },
  methods: {
    async appendCanvas(url) {
      this.options = { ...this.options, data: url };
      if (!qrCode) {
        qrCode = new QRCodeStyling(this.options);
        qrCode.append(document.getElementById("canvas-wrapper"));
        await this.$nextTick();
      } else {
        qrCode.update(this.options);
      }
      await this.$nextTick();
      await this.updateStyle();

      this.$emit("input", this.options);
      this.$emit("save", this.options);
      this.$emit("update:NewqrDesign", this.options);
    },
    updateStyle(timer = false, options = this.options) {
      this.$nextTick(() => {
        debounce(
          () => {
            try {
              if (
                this.identifier &&
                (!this.options.data ||
                  !this.options.data.includes(this.identifier))
              ) {
                this.options.data = `https://qr2.in/${this.identifier}`;
              }
              qrCode.update(options);
              this.$emit("input", options);
              this.$emit("save", options);
            } catch (e) {}
          },
          !!timer ? 500 : 7500,
        );
      });
      this.$nextTick(() => {
        setTimeout(() => {
          this.getDataUrl();
        }, 0);
      });
    },
    async getDataUrl(type = "svg") {
      try {
        if (
          this.identifier &&
          (!this.options.data || !this.options.data.includes(this.identifier))
        ) {
          this.options.data = `https://qr2.in/${this.identifier}`;
          if (qrCode) {
            qrCode.update(this.options);
          }
        }
        let blob = await qrCode.getRawData(type);
        if (!blob) {
          console.error("Failed to get QR code blob");
          return;
        }
        const reader = new FileReader();
        reader.addEventListener("loadend", () => {
          this.$emit("update:file", reader.result);
        });
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error generating SVG:", error);
      }
    },
    ranColor() {
      return new Promise((resolve) => {
        let rand = this.colors[Math.floor(Math.random() * 10)];
        this.options.dotsOptions.gradient.colorStops = [
          { offset: 0, color: rand[0] },
          { offset: 1, color: rand[1] },
        ];
        resolve("resolve");
      });
    },
  },
};
</script>
